module.exports = __webpack_public_path__ + "static/media/EditNotes.1e6aec23.svg";